import { Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getPostData } from '../services/Posts.js';
import { useEffect, useMemo, useState } from 'react';
import PostDetailsForm from './Posts/PostDetailsForm.js';
import MyTabsNested from '../components/MyTabsNested.js';
import GeneralPosts from './Posts/GeneralPosts.js';
import { useSelector } from 'react-redux';

const EditPostRecord = () => {

  const { alias } = useParams();
  const [insightTitle, setInsightTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralPosts, subTabs: [
        { id: "basic", title: "Basic", Component: PostDetailsForm }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getPostData(alias);

          if (result) {
            setInsightTitle(result?.data?.[0]?.title);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    if (!previewEnabled) {
      const pathParts = location.pathname.split('/');
      if (pathParts?.length === 3 && alias) {
        // Redirect to the default tab/subTab
        navigate(`/posts/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
      }
    } else {
      navigate(`/posts/${alias}`, {
        replace: true
      });
    }

  }, [location.pathname, alias, navigate, tabs, previewEnabled]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
      <Text fontSize={"16px"} fontWeight={"600"} pt={2}>{insightTitle}</Text>
      {previewEnabled ? <PostDetailsForm /> : <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/posts"} />}
    </Stack>
  );
};

export default EditPostRecord;